// Button and ButtonProps will be exported.
// Using the wildcard because Babel has difficulty interpreting TypeScript interfaces when they are re-exported
export * from './Button.component';
